export function bidSubmittedFormatter({ data }): string {
  const bidSubmitted = data?.bidSubmitted;

  return bidSubmitted ? 'Yes' : 'No';
}
